import React from 'react'
import './List.css'

export const List = props => (
    <ul className="List">
        {props.children}
    </ul>
)

export const ListItem = props => (
    <li className="ListItem">
        {props.children}
    </li>
)


// WEBPACK FOOTER //
// ./src/components/common/List.js